"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackFbAndCAPI } from "@/lib/fbPixel";

// Fires a Meta PageView (browser Pixel + backend CAPI) on every route
// change. The Pixel base script no longer auto-fires PageView so we can
// control the eventID per page and dedup with the backend CAPI event.
export default function MetaPageView() {
  const pathname = usePathname();
  useEffect(() => {
    trackFbAndCAPI("PageView", {});
  }, [pathname]);
  return null;
}
